"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_entertainment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aef3d3f4-dbe8-4a03-a6b7-93ce9fe8eade",
    x1: 50.08,
    y1: 31.3,
    x2: 107.64,
    y2: 88.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e0c43ff1-5b3c-4cd5-a2ed-b2016ed84233",
    x1: 103.71,
    y1: 88.52,
    x2: 158.09,
    y2: 142.89,
    xlinkHref: "#aef3d3f4-dbe8-4a03-a6b7-93ce9fe8eade"
  })), /*#__PURE__*/React.createElement("title", null, "entertainment-hi"), /*#__PURE__*/React.createElement("g", {
    id: "c0201bcd-3a4d-4a71-905f-03f5d3952b29",
    "data-name": "entertainment-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4cf810d1-5002-42df-9ab9-4e8ca732abb4",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7f9b5e81-2d03-4ba1-be7e-3dcb71beda22",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9a045eaa-8052-40c8-8f41-fd8401e188f6",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c89b4550-0e9f-4cfe-a4ba-5e91e7c6f9ee",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0afa480d-07d7-45df-a96f-d52093108768",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a412b927-d767-48be-bc51-2d2c07f8189a",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "42ea77b8-e7eb-4607-a76c-3b101eadd00e",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7c0438eb-9aac-4c86-aab3-2d0616ab8832",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1c656c98-080d-4861-9a91-9ded34c2b90c",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5781f5a8-3295-400b-96ea-96c6b3408ade",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e151b95f-6f15-438c-814e-f5c2a8834534",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.26,95c0-3.8,6.3-6.94,14.15-7a28.54,28.54,0,0,1,3.86.23c5.06-12,6.63-22.72,4.52-31.46l0-.13L93.94,21.83a9,9,0,0,0-4.54-5.74A5.27,5.27,0,0,0,84.95,16,224.66,224.66,0,0,1,21.1,34a5,5,0,0,0-1.77.58c-2.52,1.4-3.74,4.88-3,8.46,0,.09,0,.18.07.27L28.49,83.38a3.48,3.48,0,0,0,.27.64C34.47,94.66,46.33,104.48,64,113.2a20.08,20.08,0,0,0,25.87-7.3c.92-1.46,1.78-2.9,2.62-4.33C86.11,101,81.29,98.25,81.26,95ZM80,46.83c6.11-.21,11.14,2,11.24,5s-4.77,5.52-10.88,5.73-11.14-2-11.24-5S73.93,47,80,46.83ZM46.53,67.11c-5.31,3-10.81,3.38-12.27.8s1.66-7.1,7-10.12S52,54.42,53.51,57,51.85,64.09,46.53,67.11ZM69.08,82.22A24.47,24.47,0,0,0,54.15,95.05a1.27,1.27,0,0,1-2.4-.49C51.9,86.39,58.07,78.65,67.28,76s18.51.6,23,7.39a1.27,1.27,0,0,1-1.78,1.69A24.3,24.3,0,0,0,69.08,82.22Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.26,95c0-3.8,6.3-6.94,14.15-7a28.54,28.54,0,0,1,3.86.23c5.06-12,6.63-22.72,4.52-31.46l0-.13L93.94,21.83a9,9,0,0,0-4.54-5.74A5.27,5.27,0,0,0,84.95,16,224.81,224.81,0,0,1,54.16,27.22l13.41,48.7c9.09-2.5,18.27.74,22.71,7.46a1.27,1.27,0,0,1-1.78,1.69,24.33,24.33,0,0,0-19.22-2.91l8.92,32.39a20,20,0,0,0,11.68-8.65c.92-1.46,1.78-2.9,2.62-4.33C86.11,101,81.29,98.25,81.26,95ZM80.4,57.54c-6.11.21-11.14-2-11.24-5S73.93,47,80,46.83s11.14,2,11.24,5S86.51,57.34,80.4,57.54Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#aef3d3f4-dbe8-4a03-a6b7-93ce9fe8eade)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.29,101.26h0l-.1,0c-.65-.12-1.27-.27-1.87-.44h0l-.41-.12h0A16.51,16.51,0,0,1,85,99.55l-.08,0h0a10.37,10.37,0,0,1-1.71-1.11l-.14-.11h0c-.16-.13-.29-.27-.43-.41l-.15-.15h0a5.4,5.4,0,0,1-.65-.84h0l-.07-.14a4.14,4.14,0,0,1-.24-.48h0a3.75,3.75,0,0,1-.14-.43h0a3.45,3.45,0,0,1-.14-.87,3.65,3.65,0,0,1,.45-1.73,5,5,0,0,1,.64-1,6.82,6.82,0,0,1,.53-.55l.18-.16.47-.38.2-.15c.23-.16.47-.33.73-.48h0c.26-.15.53-.3.82-.44l.26-.13.67-.3.28-.12c.32-.13.64-.25,1-.36h0c.34-.11.69-.22,1-.32l.33-.09.82-.2.34-.08c.38-.08.77-.15,1.17-.22h0c.4-.06.8-.12,1.21-.16l.37,0,.94-.08.38,0c.43,0,.87,0,1.31,0,.63,0,1.24,0,1.84,0h0l.29,0h0q.88.06,1.72.16c5.06-12,6.63-22.72,4.52-31.46l0-.13L93.94,21.83a9,9,0,0,0-4.54-5.74A5.27,5.27,0,0,0,84.95,16,224.66,224.66,0,0,1,21.1,34a5,5,0,0,0-1.77.58c-2.52,1.4-3.74,4.88-3,8.46,0,.09,0,.18.07.27L28.49,83.38a3.48,3.48,0,0,0,.27.64C34.47,94.66,46.33,104.48,64,113.2a20.08,20.08,0,0,0,25.87-7.3c.92-1.46,1.78-2.9,2.62-4.33h0C91.73,101.49,91,101.39,90.29,101.26ZM80,46.83c6.11-.21,11.14,2,11.24,5s-4.77,5.52-10.88,5.73-11.14-2-11.24-5S73.93,47,80,46.83ZM46.53,67.11c-5.31,3-10.81,3.38-12.27.8s1.66-7.1,7-10.12S52,54.42,53.51,57,51.85,64.09,46.53,67.11ZM69.08,82.22A24.47,24.47,0,0,0,54.15,95.05a1.27,1.27,0,0,1-2.4-.49C51.9,86.39,58.07,78.65,67.28,76s18.51.6,23,7.39a1.27,1.27,0,0,1-1.78,1.69A24.3,24.3,0,0,0,69.08,82.22Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.24,57.79c5.31-3,10.81-3.38,12.27-.8a2.65,2.65,0,0,1,.21.48A3.28,3.28,0,0,0,53.51,55c-1.46-2.57-7-2.21-12.27.8-5,2.84-8.06,7-7.19,9.64C34.68,63,37.38,60,41.24,57.79Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.28,75.52h0Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.93,81.63c-.18-.2-.35-.41-.53-.61s-.43-.41-.64-.62-.29-.29-.45-.43-.54-.44-.81-.66l-.37-.3c-.32-.23-.65-.45-1-.67l-.28-.19c-.37-.23-.75-.44-1.13-.64l-.21-.12c-.42-.22-.85-.42-1.29-.6l-.11-.05q-.7-.3-1.43-.54h0a22,22,0,0,0-8.22-1.07l-.44,2a23.46,23.46,0,0,0-4.73.84C58.64,80.48,52.68,87.45,51.84,95c0,0,0-.08,0-.12a1.28,1.28,0,0,0,2.34.13,23.69,23.69,0,0,1,34.36-10,1.26,1.26,0,0,0,.85.17,1.32,1.32,0,0,0,.38-.13V82.64c-.12-.16-.22-.32-.35-.48S89.08,81.81,88.93,81.63Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.28,78A23.46,23.46,0,0,1,72,77.15l.44-2a23.25,23.25,0,0,0-3.17.39h0q-.85.17-1.7.4l-.29.07c-9.21,2.66-15.38,10.4-15.54,18.57a1.16,1.16,0,0,0,.06.36s0,.08,0,.12C52.68,87.45,58.64,80.48,67.28,78Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.28,78A23.46,23.46,0,0,1,72,77.15l.44-2a23.25,23.25,0,0,0-3.17.39h0q-.85.17-1.7.4l-.29.07c-9.21,2.66-15.38,10.4-15.54,18.57a1.16,1.16,0,0,0,.06.36s0,.08,0,.12C52.68,87.45,58.64,80.48,67.28,78Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8,94.92a1.16,1.16,0,0,1-.06-.36A1.1,1.1,0,0,0,51.8,94.92Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8,94.92a1.16,1.16,0,0,1-.06-.36A1.1,1.1,0,0,0,51.8,94.92Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8,94.92a1.16,1.16,0,0,1-.06-.36A1.1,1.1,0,0,0,51.8,94.92Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.46,75.11a23.2,23.2,0,0,0-3.17.41,23.25,23.25,0,0,1,3.17-.39Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.46,75.11a23.2,23.2,0,0,0-3.17.41,23.25,23.25,0,0,1,3.17-.39Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.46,75.11a23.2,23.2,0,0,0-3.17.41,23.25,23.25,0,0,1,3.17-.39Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.28,75.52c-.66.13-1.33.28-2,.47l.29-.07Q68.43,75.68,69.28,75.52Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.28,75.52c-.66.13-1.33.28-2,.47l.29-.07Q68.43,75.68,69.28,75.52Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.28,75.52c-.66.13-1.33.28-2,.47l.29-.07Q68.43,75.68,69.28,75.52Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,111.2C46.33,102.48,34.47,92.66,28.76,82a3.48,3.48,0,0,1-.27-.64L16.43,41.32q0-.13-.07-.27A10.14,10.14,0,0,1,16.19,40,9.85,9.85,0,0,0,16.36,43q0,.14.07.27L28.49,83.38a3.48,3.48,0,0,0,.27.64C34.47,94.66,46.33,104.48,64,113.2c.38.19.77.36,1.15.52,0-.69-.08-1.37-.1-2C64.71,111.53,64.36,111.37,64,111.2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.49,71.14a6.77,6.77,0,0,0-4.92-2.91A288.59,288.59,0,0,1,87.63,48.65a6.35,6.35,0,0,0-2.36-.45c-3.7,0-7.24,3.15-8.61,7.65q-.05.17-.09.35L65.14,108.72a4.45,4.45,0,0,0-.1.89c-.22,15.51,7,33.94,21.39,54.76A25.8,25.8,0,0,0,120,172.3c25.75-14.13,41.76-30.24,46.3-46.58l0-.17L177,80.42A11.5,11.5,0,0,0,175.49,71.14ZM81.26,95c0-3.8,6.3-6.94,14.15-7s14.24,2.95,14.28,6.75-6.3,6.94-14.15,7S81.3,98.75,81.26,95Zm55.43,43c-5.34,9-17.09,13.75-29,10.93s-20.39-12.38-21.11-22.85a1.63,1.63,0,0,1,3.05-.78c3,5.34,9.15,13,20,15.53a31.21,31.21,0,0,0,24.75-4.89A1.63,1.63,0,0,1,136.69,138Zm18.64-25.56c-1.73,3.38-8.8,3.23-15.79-.35s-11.25-9.22-9.52-12.6,8.8-3.23,15.79.34S157.06,109,155.33,112.43Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.3,135.92a31.21,31.21,0,0,1-24.75,4.89c-10.81-2.55-16.92-10.19-20-15.53a1.63,1.63,0,0,0-3.05.78c.71,10.47,9.12,20,21.11,22.85s23.71-1.94,29-10.93A1.63,1.63,0,0,0,134.3,135.92Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,46.83a22.65,22.65,0,0,1,2.28,0,7.09,7.09,0,0,1,2.95-.67,6.35,6.35,0,0,1,2.36.45l2.62,1c-1.79-1.81-5.7-3-10.21-2.83-6.11.21-11,2.78-10.88,5.73a2.72,2.72,0,0,0,.2.89C70.33,49,74.71,47,80,46.83Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,78.42l-10.64,45.13,0,.17c-4.54,16.34-20.55,32.45-46.3,46.58a25.8,25.8,0,0,1-33.61-7.93c-12.55-18.12-19.62-34.42-21.1-48.58l-.16-.06c1,14.62,8.1,31.63,21.26,50.64A25.8,25.8,0,0,0,120,172.3c25.75-14.13,41.76-30.24,46.3-46.58l0-.17L177,80.42a13,13,0,0,0,.3-4A13.27,13.27,0,0,1,177,78.42Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.3,135.92a31.21,31.21,0,0,1-24.75,4.89c-10.81-2.55-16.92-10.19-20-15.53a1.63,1.63,0,0,0-3.05.78c0,.42.09.83.14,1.25a1.67,1.67,0,0,1,2.91,0c3,5.34,9.15,13,20,15.53a31.21,31.21,0,0,0,24.75-4.89,1.68,1.68,0,0,1,2.22.32l.17-.26A1.63,1.63,0,0,0,134.3,135.92Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.17,111.73l-.1,0c0,.68.05,1.36.1,2l.16.06C65.26,113.09,65.21,112.41,65.17,111.73Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,109.61c0,.68,0,1.38,0,2.08l.1,0q-.08-1.19-.1-2.36C65.06,109.45,65,109.53,65,109.61Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,86.27l-.76-.11a28.54,28.54,0,0,0-3.86-.23c-7.85.07-14.18,3.22-14.15,7a3.46,3.46,0,0,0,.17,1c1-3.32,6.86-5.92,14-6a29,29,0,0,1,3,.13l.84.1c5.35.68,9.43,2.84,10.25,5.55a3.46,3.46,0,0,0,.17-1C109.66,89.67,105.62,87.15,100,86.27Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.27,46.2a7.09,7.09,0,0,0-2.95.67c3.52.24,6.45,1.3,7.92,2.8l1,.4c0-.08,0-.17,0-.25a3.23,3.23,0,0,0-1-2.14l-2.62-1A6.35,6.35,0,0,0,85.27,46.2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.33,125.72l0-.17L177,80.42a11.5,11.5,0,0,0-1.52-9.28,6.77,6.77,0,0,0-4.92-2.91A288.73,288.73,0,0,1,130.28,62l-21,78.78.29.08a31.21,31.21,0,0,0,24.75-4.89,1.63,1.63,0,0,1,2.39,2.06c-5.34,9-17.09,13.75-29,10.93l-.53-.15-6.84,25.62A25.69,25.69,0,0,0,120,172.3C145.79,158.16,161.8,142.06,166.33,125.72Zm-26.79-13.64c-7-3.57-11.25-9.22-9.52-12.6s8.8-3.23,15.79.34,11.25,9.22,9.52,12.6S146.53,115.65,139.55,112.08Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#e0c43ff1-5b3c-4cd5-a2ed-b2016ed84233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.81,97.83c-7-3.57-14.06-3.73-15.79-.34a4,4,0,0,0-.26,2.69,3.42,3.42,0,0,1,.26-.69c1.73-3.38,8.8-3.23,15.79.34,5.35,2.74,9.1,6.69,9.78,9.91C156.49,106.31,152.34,101.17,145.81,97.83Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))))))))))))));
}

var _default = ic_entertainment;
exports.default = _default;